import React from 'react'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@material-ui/core'
import { Check as CheckIcon, X as XIcon } from 'react-feather'

import useStyles from './styles'
import useClipboard from 'hooks/useClipboard'

const MetList = ({ mets = [], fieldName = '', hasCopy }) => {
  const classes = useStyles()

  const { copy } = useClipboard()

  const handleCopyToClipboard = (text) => {
    copy(text)
  }

  return (
    <List className={classes.metsList}>
      {mets.map((item, index) => (
        <ListItem key={index} className={classes.metItem}>
          <ListItemIcon className={classes.metIcon}>
            {item.met ? (
              <CheckIcon className={classes.checkIcon} size={20} />
            ) : (
              <XIcon className={classes.xIcon} size={20} />
            )}
          </ListItemIcon>
          <ListItemText
            primary={item[fieldName]}
            secondary={
              hasCopy ? (
                <Tooltip
                  title="Clique para copiar o conteúdo"
                  placement="top"
                  arrow
                >
                  <span
                    onClick={() => handleCopyToClipboard(item.observation)}
                    className={classes.copyHighlight}
                  >
                    {item.observation}
                  </span>
                </Tooltip>
              ) : (
                item.observation
              )
            }
            classes={{
              primary: classes.metPrimary,
              secondary: classes.metSecondary,
            }}
          />
        </ListItem>
      ))}
    </List>
  )
}

export default MetList
